export const SUPPORTED_CURRENCIES = [
  'GBP', 'EUR', 'USD', 'CAD', 'CHF', 
  'DKK', 'NOK', 'SEK', 'PLN', 'RON', 
  'CZK', 'HUF', 'ILS', 'BRL', 'ZAR'
] as const;

export const FEATURES = [
  'SEPA payments and SWIFT including multicurrency',
  'Currency exchange',
  'Instant internal transfers',
  'Account number issuing',
  'Multi-currency accounts',
  'Bulk payments',
  'Cross border SWIFT payments',
  'Local account details (IBANs) in major currencies like GBP, EUR, USD, CAD, CHF and others, paired with competitive FX rates',
] as const;

export const CONTACT_INFO = {
  email: 'info@gcbusiness.space',
  phone: '+442046219434',
  hours: 'Mon - Fri: 9:00 AM - 6:00 PM',
  location: 'London, United Kingdom',
  whatsapp: 'https://wa.me/442046219434',
} as const;

export const ROUTES = {
  HOME: '/',
  OPEN_ACCOUNT: '/open-account',
  PRIVACY: '/privacy',
  RESTRICTED_JURISDICTIONS: '/restricted-jurisdictions',
} as const;

